module.exports = __webpack_public_path__ + "img/santa_monica_stickers_vert.92c73918.png";